module.exports = __webpack_public_path__ + "static/media/boat-img-21.2198f47a.jpg";